"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unifyByType = void 0;
const lodash_1 = __importDefault(require("lodash"));
const Actions = __importStar(require("../actions"));
const closure_1 = require("../closure");
const ctx_1 = require("../ctx");
const equivalent_1 = require("../equivalent");
const Errors = __importStar(require("../errors"));
const Neutrals = __importStar(require("../neutral"));
const solution_1 = require("../solution");
const unify_1 = require("../unify");
const freshen_1 = require("../utils/freshen");
const Values = __importStar(require("../value"));
function unifyByType(mod, ctx, type, left, right) {
    switch (type["@kind"]) {
        case "Type": {
            (0, unify_1.unifyType)(mod, ctx, left, right);
            return "ok";
        }
        case "Trivial": {
            return "ok";
        }
        case "Pi": {
            const name = type.retTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
            const freshName = (0, freshen_1.freshen)(usedNames, name);
            const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName));
            const retType = (0, closure_1.closureApply)(type.retTypeClosure, v);
            ctx = (0, ctx_1.CtxCons)(freshName, type.argType, ctx);
            const leftRet = Actions.doAp(left, v);
            const rightRet = Actions.doAp(right, v);
            // NOTE Should not use `unify`, which will
            //   capture bound variables and make them out of scope.
            // unify(mod, ctx, retType, leftRet, rightRet)
            (0, equivalent_1.equivalent)(mod, ctx, retType, leftRet, rightRet);
            return "ok";
        }
        case "PiImplicit": {
            const name = type.retTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
            const freshName = (0, freshen_1.freshen)(usedNames, name);
            const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName));
            const retType = (0, closure_1.closureApply)(type.retTypeClosure, v);
            ctx = (0, ctx_1.CtxCons)(freshName, type.argType, ctx);
            const leftRet = Actions.doApImplicit(left, v);
            const rightRet = Actions.doApImplicit(right, v);
            // NOTE Should not use `unify`, which will
            //   capture bound variables and make them out of scope.
            // unify(mod, ctx, retType, leftRet, rightRet)
            (0, equivalent_1.equivalent)(mod, ctx, retType, leftRet, rightRet);
            return "ok";
        }
        case "Sigma": {
            const leftCar = Actions.doCar(left);
            const rightCar = Actions.doCar(right);
            (0, unify_1.unify)(mod, ctx, type.carType, leftCar, rightCar);
            const car = Actions.doCar(left);
            const cdrType = (0, closure_1.closureApply)(type.cdrTypeClosure, car);
            const leftCdr = Actions.doCdr(left);
            const rightCdr = Actions.doCdr(right);
            (0, unify_1.unify)(mod, ctx, cdrType, leftCdr, rightCdr);
            // equivalent(mod, ctx, cdrType, leftCdr, rightCdr)
            return "ok";
        }
        case "ClazzNull":
        case "ClazzCons":
        case "ClazzFulfilled": {
            assertNoExtraCommonProperties(type, left, right);
            (0, unify_1.unifyProperties)(mod, ctx, type, left, right);
            return "ok";
        }
    }
}
exports.unifyByType = unifyByType;
function assertNoExtraCommonProperties(clazz, left, right) {
    if (left["@kind"] === "Objekt" && right["@kind"] === "Objekt") {
        const clazzNames = Values.clazzPropertyNames(clazz);
        const leftNames = Object.keys(left.properties);
        const rightNames = Object.keys(right.properties);
        const extraCommonNames = lodash_1.default.intersection(lodash_1.default.difference(leftNames, clazzNames), lodash_1.default.difference(rightNames, clazzNames));
        if (extraCommonNames.length > 0) {
            throw new Errors.UnificationError([
                `[unifyByType] on Clazz, expect no extra common names`,
                `  found: ${extraCommonNames.join(" ")}`,
            ].join("\n"));
        }
    }
}
//# sourceMappingURL=unifyByType.js.map